import * as types from './actionTypes';

export function loadingRes(data) {  
  return {
    type: types.DO_LOADING_RES,
    data
  };
}
